import { useDispatch, useSelector } from "react-redux";
import WeekCalendar from "../containers/WeekCalendar";
import { useEffect } from "react";
import { checkAuthenticated } from "../actions/auth";

const HomePage = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(checkAuthenticated());
  }, []);
  return (
    <div className="content calendar-app gap-2">
      <div className="d-flex justify-content-between align-items-center page-title">
        <h1>Inicio</h1>
      </div>
      <div className="d-flex flex-column gap-2">
        <div className="week-calendar">
          {user && <WeekCalendar profileId={user.id} />}
        </div>
        <div className="month-summary"></div>
      </div>
    </div>
  );
};

export default HomePage;
